export enum MessageEventType {
    FirstMessage = 1,
    PurchaseRequest,
    CallbackRequest
}